document.addEventListener('DOMContentLoaded', () => {
    const popupWrapper = document.querySelector('.newsletter-popup--wrapper');

    if (popupWrapper) {
        const close = document.querySelector('.newsletter-popup--close');
        const cookieName = "newsletter_popup";
        const daysToExpire = popupWrapper.getAttribute('data-cookie-expire');

        if (cookieExpired()) {
            popupWrapper.classList.add('show');
        }

        close.addEventListener('click', () => {
            closePopup();
        });

        function closePopup() {
            setCookie();
            popupWrapper.remove();
        }

        function setCookie() {
            const date = new Date();
            date.setTime(date.getTime() + (parseInt(daysToExpire) * 24 * 60 * 60 * 1000));
            document.cookie = cookieName + "=1;domain="+window.location.host+";expires=" + date.toUTCString() + ";path=/";
        }

        function cookieExpired() {
            const cookies = document.cookie;
            const cookieStartIndex = cookies.indexOf(cookieName + "=");
            return cookieStartIndex === -1;
        }
    }
});
